export default function buildDeeplinkUri(
  appPath: string,
  utility?: string,
): string {
  const encodedPath = encodeURIComponent(appPath)
  return `${window.location.origin}${
    utility ? `/${utility}` : ''
  }/device-traffic-control/navigate?url=${encodedPath}`
}
